import React, { useState, useEffect, useRef } from "react";
import {
  getDatabase,
  ref,
  onValue,
  push,
  set,
  remove,
} from "firebase/database";
import { onAuthStateChanged, getAuth, signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaRegFolderOpen ,FaFolderPlus ,FaCloudUploadAlt,FaRedo } from "react-icons/fa";
import { FaFolderOpen } from "react-icons/fa6";
import "./css/dashboard.css";
import { AiFillFolderOpen } from "react-icons/ai";

const Upload = () => {
  const navigate = useNavigate();
  const db = getDatabase();

  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);

  const [folders, setFolders] = useState([]);
  const [newFolderName, setNewFolderName] = useState("");
  const [userEmail, setUserEmail] = useState(null);
  const [userName, setUserName] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState("");
  const [uploadProgress, setUploadProgress] = useState(null);
  const [notification, setNotification] = useState("");
  const [showAllFolders, setShowAllFolders] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showDropdown, setShowDropdown] = useState(false);
const [folderThumbnails, setFolderThumbnails] = useState({});
const [activeAction, setActiveAction] = useState(""); 
const [menuOpen, setMenuOpen] = useState(false);
  const [showMobileWarning, setShowMobileWarning] = useState(false); // ✅ FIXED
    const [selectedImage, setSelectedImage] = useState("/media/default-avatar.png");
      const [uploading, setUploading] = useState(false);
 useEffect(() => {
    const storedImage = localStorage.getItem("profileImage");
    if (storedImage) setSelectedImage(storedImage);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const emailKey = user.email.replace(/\./g, "_");
        setUserEmail(emailKey);
        setUserName(user.displayName || "User");
        fetchFolders(emailKey);
      } else {
        navigate("/login");
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    if (isMobile) {
      setShowMobileWarning(true);
      const timer = setTimeout(() => setShowMobileWarning(false), 3000);
      return () => clearTimeout(timer);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  useEffect(() => {
    fetchFolderThumbnails().then(setFolderThumbnails);
  }, []);

  const fetchFolders = (emailKey) => {
    const folderRef = ref(db, `users/${emailKey}/folders`);
    onValue(folderRef, (snapshot) => {
      const data = snapshot.val();
      const folderList = data
        ? Object.entries(data).map(([id, folder]) => ({ id, ...folder }))
        : [];
      setFolders(folderList);
    });
  };

  const fetchFolderThumbnails = async () => {
    try {
      const res = await fetch("https://lifoura.com/get_uploaded.php");
      const data = await res.json();

      if (!data.files) return {};

      const folderThumbnails = {};

      data.files.forEach((file) => {
        const [folderName] = file.file_name.split("-");
        const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(file.file_name);
        if (isImage && !folderThumbnails[folderName]) {
          folderThumbnails[folderName] = file.url + "?t=" + Date.now();
        }
      });

      return folderThumbnails;
    } catch (error) {
      console.error("Failed to fetch thumbnails:", error);
      return {};
    }
  };

  const createFolder = async () => {
    if (!newFolderName.trim() || !userEmail) {
      return showNotification("Enter a valid folder name.");
    }
    const folderRef = ref(db, `users/${userEmail}/folders`);
    const newRef = push(folderRef);
    await set(newRef, {
      name: newFolderName.trim(),
      createdAt: Date.now(),
    });
    showNotification(`Folder "${newFolderName.trim()}" created.`);
    setNewFolderName("");
  };

  const deleteFolder = async (folderId, folderName) => {
    if (!window.confirm(`Delete folder "${folderName}"?`)) return;
    const folderRef = ref(db, `users/${userEmail}/folders/${folderId}`);
    await remove(folderRef);
    showNotification(`Folder "${folderName}" deleted.`);
  };

const handleBulkUpload = async (files) => {
    if (!selectedFolder || files.length === 0) {
      return alert("Please select a folder and some files first.");
    }

    setUploading(true);

    const uploadPromises = files.map(async (file) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("folder", selectedFolder);

      try {
        const response = await fetch("https://lifoura.com/uploads/uploads.php", {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Server error:", errorText);
          return { error: true, message: errorText };
        }

        const data = await response.json();
        return data.status === "success"
          ? { error: false }
          : { error: true, message: data.message || "Upload failed" };
      } catch (err) {
        console.error("Network error:", err);
        return { error: true, message: err.message };
      }
    });

    const results = await Promise.all(uploadPromises);
    setUploading(false);

    const failed = results.filter((r) => r.error);
    if (failed.length) {
      alert("Some uploads failed. Check console for details.");
    } else {
      alert("All files uploaded successfully.");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageDataUrl = reader.result;
        setSelectedImage(imageDataUrl);
        localStorage.setItem("profileImage", imageDataUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleView = (folder) => {
    navigate(`/folder/${encodeURIComponent(folder.name)}`);
  };

  const showNotification = (msg) => {
    setNotification(msg);
    setTimeout(() => setNotification(""), 3000);
  };

  const filteredFolders = showAllFolders
    ? folders
    : selectedFolder
    ? folders.filter((folder) => folder.name === selectedFolder)
    : [];

  return (
    <div className={`navbar-container ${isMobile ? "mobile" : "desktop"}`}>
    {/* ✅ Desktop UI */}
      {!isMobile && (
        <div className="mainbar desktop">
  <div className="logo-section">
    <img src="/assets/lifoura-04.png" alt="LifeVault Logo" className="logo-image" />
  </div>
  <div className="nav-links">
    <button className="nav-btn" onClick={() => navigate("/")}>Home</button>
    <button
      className="nav-btn logout"
      onClick={() => {
        signOut(auth).then(() => navigate("/login"));
      }}
    >
      Logout
    </button>
  </div>
</div>

      )}

      {/* ✅ Mobile UI */}
      {isMobile && (
        <div className="mainbar mobile">
          <div className="mobile-header">
            <img src="/assets/lifoura-04.png" alt="LifeVault Logo" className="logo-image center" /><br></br>
            <button className="mobile-menu "onClick={() => { navigate("/"); setMenuOpen(false); }}>Home</button>
              <button className="mobile-menu "onClick={() => setMenuOpen(false)}>Logout</button>
          </div>
        </div>
      )}

    <div className="upload-wrapper">
      {isMobile && showMobileWarning &&(
        <div className="mobile-warning">
          📱 For best experience, use a desktop browser.
        </div>
      )}

   <div className="header-container fancy-header">
  <div className="welcome-text">
    <h2 className="welcome-title gradient-text animate-fade-in">
      Welcome back, {userName} 👋
    </h2>
    <p className="welcome-subtitle subtle-fade">
      Let your memories live forever in your personal vault ✨
    </p>
  </div><br></br>

  <div className="profile-container">
      <img
        src={selectedImage}
        alt="Profile"
        className="profile-image"
        onClick={() => document.getElementById("avatarUpload").click()}
        title="Click to change avatar"
      />
      <input
  id="avatarUpload"
  type="file"
  accept="image/*"
  style={{ display: "none" }}
  onChange={handleImageUpload}
/>
    </div>
</div>


      {uploadProgress !== null && (
        <div className="upload-progress-bar">
          <div
            className="upload-progress-fill"
            style={{ width: `${uploadProgress}%` }}
          >
            {uploadProgress}%
          </div>
        </div>
      )}

      {notification && <div className="notification-toast">{notification}</div>}

   {isMobile ? (
        // 🔹 Mobile UI
        <div className="mobile-button-group">
          <div className="mobile-option">
            <FaFolderPlus size={40} />
            <h4>Create Folder</h4>
            <button onClick={() => {
              setShowAllFolders(false);
              setActiveAction("create");
            }}>
              Tap to Create
            </button>
          </div>

          <div className="mobile-option">
            <FaCloudUploadAlt size={40} />
            <h4>Upload Memory</h4>
            <button onClick={() => {
  if (folders.length === 0) {
    showNotification("Create a folder first!");
    folderInputRef.current?.focus();
  } else {
    setShowDropdown(true);
    setActiveAction("upload");
  }
}}>

              Upload
            </button>

          </div>

          <div className="mobile-option">
            <FaRedo size={40} />
            <h4>Explore</h4>
            <button onClick={() => {
              setShowAllFolders(true);
              setActiveAction("explore");
            }}>
              View Timeline
            </button>
          </div>
        </div>
      ) : (    <div className="button-group">
  {/* Create Folder */}
  <button
      className={`vault-button ${activeAction === "create" ? "active-button" : ""}`}
  onClick={() => {
     setShowAllFolders(false);
      setSelectedFolder("");
      setShowDropdown(false);
      setActiveAction("create");
  }}
  ><br></br>
    <FaFolderPlus className="vault-icon" size={50} /><br></br><br></br>
    <h3 style={{fontFamily: 'serif',}}>Create Folder</h3>
    <p>Setup a secure vault </p>
  </button>


  {/* Upload Memory */}
<button
  className={`vault-button ${activeAction === "upload" ? "active-button" : ""}`}
  onClick={() => {
    if (activeAction === "upload") return;

    setShowAllFolders(false);
    setSelectedFolder("");

  if (folders.length === 0) {
  showNotification("No folders found. Please create a folder first.");
  folderInputRef.current?.focus();
  folderInputRef.current?.classList.add("highlight");
  setTimeout(() => folderInputRef.current?.classList.remove("highlight"), 2000);
}else {
      setShowDropdown(true);
      setActiveAction("upload");
    }
  }}
  disabled={activeAction === "upload"}
>
  <br />
  <FaCloudUploadAlt className="vault-icon" size={50} />
  <br /><br />
  <h3 style={{ fontFamily: "serif" }}>Upload Memory</h3>
  <p>Upload your memories</p>
</button>


  {/* Explore Timeline */}
  <button
   className={`vault-button ${activeAction === "explore" ? "active-button" : ""}`}
  onClick={() => {
    setShowAllFolders(true);
    setSelectedFolder("");
    setShowDropdown(false);
    setActiveAction("explore");
  }}
  ><br></br>
    <FaRedo className="vault-icon" size={50}/><br></br><br></br>
    <h3 style={{fontFamily: 'serif',}}>Explore Timeline</h3>
    <p>Relive Anytime,Forever</p>
  </button>
</div>) }<br></br><br></br>



{activeAction === "upload"&& showDropdown && (
  <div>

   {isMobile ? (
      // ✅ Mobile UI
      <div className="mobile-upload-dropdown dropdown-list">
        <div className="dropdown-header">Select Folder</div>
  {folders.length === 0 ? (
    <div className="no-folders">No folders available. Create one first.</div>
  ) : (
    folders.map((folder) => (
      <div
        key={folder.id}
        onClick={() => {
          setSelectedFolder(folder.name);
          fileInputRef.current?.click(); // Directly open upload on tap
        }}
        className={`dropdown-item ${selectedFolder === folder.name ? "selected" : ""}`}
      >
        <FaFolderOpen size={18} className="folder-icon" />
        <div className="folder-details">
          <span className="folder-name">{folder.name}</span>
          <span className="folder-subtext"> folder</span>
        </div>
      </div>
    ))
  )}

  {/* Hidden file input triggered by folder tap */}
  <input
    ref={fileInputRef}
    type="file"
    multiple
    accept="image/*,video/*"
    style={{ display: "none" }}
    onChange={(e) => {
      const files = Array.from(e.target.files);
      if (files.length > 0) handleBulkUpload(files);
      e.target.value = "";
    }}
  />

  {uploading && <p className="uploading-text">Uploading...</p>}
  {notification && <div className="notification">{notification}</div>}
</div>

    ) : (<div>
    <h1 className="upload-heading">Upload New Memory</h1>
    
    
  <div className="dropdown-menu-inline">
    
    <div className="dropdown-header">Select Folder</div>
 <div className="dropdown-list">
      {folders.length === 0 ? (
        <div className="no-folders">No folders available. Create one first.</div>
      ) : (
        folders.map((folder) => (
          <label
            key={folder.id}
            htmlFor="hiddenUpload"
            onClick={() => setSelectedFolder(folder.name)}
            className={`dropdown-item ${selectedFolder === folder.name ? "selected" : ""}`}
            style={{ cursor: "pointer" }}
          >
            <FaFolderOpen size={18} className="folder-icon" />
            <div className="folder-details">
              <span className="folder-name">{folder.name}</span>
              <span className="folder-subtext"> Folder</span>
            </div>
          </label>
        ))
      )}

      {/* Hidden input placed outside loop */}
      <input
        id="hiddenUpload"
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*,video/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const files = Array.from(e.target.files);
          if (files.length > 0 && selectedFolder) handleBulkUpload(files, selectedFolder);
          e.target.value = "";
        }}
      />

      {uploading && <p className="uploading-text">Uploading...</p>}
      {notification && <div className="notification">{notification}</div>}
    </div>

  </div><br></br>
  </div>)}
<input
  type="text"
  ref={folderInputRef}
  value={newFolderName}
  onChange={(e) => setNewFolderName(e.target.value)}
  onKeyDown={(e) => e.key === "Enter" && createFolder()}
  style={{ display: "none" }}
/>
  </div>
)}



      {activeAction === "create" &&!showAllFolders  && !showDropdown &&(
        <div>
         {isMobile ? (
      // ✅ Mobile UI
      <div className="mobile-folder-creation">
        <h3 className="mobile-folder-title">Create New Vault</h3>

        <input
          type="text"
          placeholder="Folder name"
          value={newFolderName}
          ref={folderInputRef}
          onChange={(e) => setNewFolderName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && createFolder()}
          className="mobile-folder-input"
        />

        <button className="mobile-folder-button" onClick={createFolder}>
          Create Folder
        </button>
      </div>
    ) :(<div className="folder-section">
          <input
            type="text"
            placeholder="Enter new folder name"
            value={newFolderName}
            ref={folderInputRef}
            onChange={(e) => setNewFolderName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && createFolder()}
            className="folder-name-input"
          />
          <button onClick={createFolder}>Create</button>

        </div>)}
        </div>
      )}

{(activeAction === "explore"||showAllFolders || selectedFolder) && (
  <div>
  {isMobile ? (
      // ✅ MOBILE UI
      <div className="mobile-memory-list">
        {filteredFolders.map((folder) => {
          const thumbnailUrl = folderThumbnails[folder.name];
          const hasThumbnail = Boolean(thumbnailUrl);

          return (
            <motion.div
              key={folder.id}
              className="mobile-memory-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div
                className="mobile-card-content"
                onClick={() => setSelectedFolder(folder.name)}
              >
                {hasThumbnail ? (
                  <img
                    src={thumbnailUrl}
                    alt={folder.name}
                    className="mobile-thumbnail"
                  />
                ) : (
                  <div className="mobile-placeholder">
                    <AiFillFolderOpen size={30} color="#fcd34d" />
                  </div>
                )}

                <div className="mobile-folder-info">
                  <h4>{folder.name}</h4>
                  <button onClick={() => handleView(folder)}>View</button>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    ) :(<div className="memory-grid">
    {filteredFolders.map((folder) => {
      const firstImage = folder.files?.find(file =>
        file.type?.startsWith("image/")
      );
      const thumbnailUrl = folderThumbnails[folder.name];

      const hasThumbnail = Boolean(thumbnailUrl);

      return (
        <motion.div
          key={folder.id}
          className={`memory-card ${hasThumbnail ? "with-thumbnail" : "no-thumbnail"}`}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div
            className="card-content"
            onClick={() => setSelectedFolder(folder.name)}
            onDoubleClick={() => deleteFolder(folder.id, folder.name)}
          >
            {hasThumbnail ? (
              <img
                src={thumbnailUrl}
                alt={folder.name}
                className="memory-image"
              />
            ) : (
              <div className="memory-placeholder">
                <AiFillFolderOpen size={40} color="#f8e9d2" />
              </div>
            )}

            <h3 className="memory-label">{folder.name}</h3>
          </div>

          <button className="view-btn" onClick={() => handleView(folder)}>
            View
          </button>
        </motion.div>
      );
    })}
  </div>)}
  </div>
)}


    </div>
    </div>
  );
};

export default Upload;
